import Wallkit from "./wallkit.esm.min";
import {EventBus} from "../utils/event-bus";
import Environment from '../utils/environment';
import debug from "../utils/debug";

export default {
  install: async (Vue) => {
    if (window) {
      Wallkit.init({
        resource: Environment.getOuterResourceId(),
        version: Environment.getOuterVersion(),
        api_url: process.env.BASE_URL,
        debug: debug.getDebugMode()
      });
    }

    Vue.prototype.$wallkit = Wallkit;
    EventBus.$emit('wallkit-init');
  }
};



// WEBPACK FOOTER //
// ./src/plugins/wallkit.js